var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckicon = function SvgCheckicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.678 4.2-8.48 8.48a.4.4 0 0 1-.568 0L1.318 8.368a.4.4 0 0 1 0-.568l.56-.56a.4.4 0 0 1 .568 0l3.464 3.464 7.64-7.64a.408.408 0 0 1 .568 0l.56.568a.4.4 0 0 1 0 .568Z"
  })));
};
export default SvgCheckicon;